<div *ngIf="view.contextMenuVisible" class="context-menu" [style.top.px]="view.menuY" [style.left.px]="view.menuX" (click)="$event.stopPropagation()">
  <ng-container *ngIf="view.contextMenuMode === 'folder'; else fileContextMenu">
    <button class="context-item" type="button" (click)="view.openCreateFolderDialogFromContext(createFolderDialog)">
      <mat-icon aria-hidden="true">create_new_folder</mat-icon>
      <span>{{ view.translate('breadcrumbs.popover.create_option') || 'Nueva carpeta' }}</span>
    </button>
  </ng-container>

  <ng-template #fileContextMenu>
    <button class="context-item" type="button" (click)="view.askAboutContextFile()">
      <mat-icon aria-hidden="true">forum</mat-icon>
      <span>{{ view.translate('documents.context.ask_only_this') }}</span>
    </button>
    <button class="context-item" type="button" (click)="view.openGenerateSummaryFromContext()">
      <i class="fas fa-wand-magic-sparkles context-item-fa" aria-hidden="true"></i>
      <span>{{ view.translate('drive.contextMenu.generateSummary') }}</span>
    </button>
    <button *ngIf="view.docVersioningEnabled" class="context-item" type="button" (click)="view.openVersionHistoryFromContext()">
      <mat-icon aria-hidden="true">history</mat-icon>
      <span>{{ view.translate('documents.versions.action') }}</span>
    </button>
    <button class="context-item" type="button" (click)="view.openMoveDialogFromContext(moveDialog)">
      <mat-icon aria-hidden="true">drive_file_move</mat-icon>
      <span>{{ view.translate('drive.context.move_to') }}</span>
      <mat-icon class="context-chevron" aria-hidden="true">chevron_right</mat-icon>
    </button>
    <button class="context-item danger" type="button" (click)="view.deleteContextFile(deleteConfirmDialog)">
      <mat-icon aria-hidden="true">delete</mat-icon>
      <span>{{ view.translate('documents.delete_document_tooltip') }}</span>
    </button>
  </ng-template>
</div>

<ng-template #deleteConfirmDialog>
  <div class="drive-dialog delete-confirm-dialog">
    <h2 mat-dialog-title>{{ view.translate('documents.delete_confirm.title') }}</h2>
    <div mat-dialog-content class="delete-confirm-content">
      <p class="delete-confirm-name">{{ view.deleteDialogName }}</p>
      <p class="delete-confirm-warning">{{ view.translate('documents.delete_confirm.body') }}</p>
    </div>
    <div mat-dialog-actions align="end" class="delete-confirm-actions">
      <button mat-button type="button" mat-dialog-close [disabled]="view.deleteDialogBusy">{{ view.translate('common.cancel') }}</button>
      <button mat-button type="button" class="delete-confirm-btn danger" (click)="view.confirmDeleteDialog()" [disabled]="view.deleteDialogBusy">
        {{ view.translate('documents.delete_confirm.confirm') }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #moveDialog>
  <div class="move-dialog">
    <h2 mat-dialog-title>{{ view.translate('drive.move_dialog.title') }}</h2>
    <div mat-dialog-content class="move-dialog-content">
      <div class="move-dialog-summary">
        <mat-icon aria-hidden="true">drive_file_move</mat-icon>
        <span>{{ view.moveDialogFilesLabel() }}</span>
      </div>

      <mat-form-field appearance="outline" class="move-search">
        <mat-label>{{ view.translate('drive.move_dialog.search') }}</mat-label>
        <input matInput [(ngModel)]="view.moveDialogSearch" [disabled]="view.moveDialogBusy">
      </mat-form-field>

      <div class="move-error" *ngIf="view.moveDialogError">
        <mat-icon aria-hidden="true">error_outline</mat-icon>
        <span>{{ view.moveDialogError }}</span>
      </div>

      <div class="move-target-list" *ngIf="view.moveDialogFolderOptions.length > 0; else noMoveTargetsDialog">
        <button class="move-target" type="button" *ngFor="let folder of view.moveDialogFolderOptions; trackBy: view.trackById" (click)="view.moveDialogMoveToFolder(folder)" [disabled]="view.moveDialogBusy">
          <mat-icon aria-hidden="true">folder</mat-icon>
          <span>
            <strong>{{ view.displayName(folder.name) }}</strong>
            <small>{{ folder.path.join(' / ') }}</small>
          </span>
          <mat-icon aria-hidden="true">chevron_right</mat-icon>
        </button>
      </div>

      <ng-template #noMoveTargetsDialog>
        <div class="move-empty">
          <mat-icon aria-hidden="true">folder_off</mat-icon>
          <span>{{ view.translate('drive.context.no_move_targets') }}</span>
        </div>
      </ng-template>
    </div>

    <div mat-dialog-actions align="end" class="move-dialog-actions">
      <div class="move-progress" *ngIf="view.moveDialogBusy">
        <mat-spinner diameter="18"></mat-spinner>
        <span>{{ view.translate('drive.move_dialog.moving') }}</span>
      </div>
      <button mat-button type="button" (click)="view.moveDialogCreateFolder()" [disabled]="view.moveDialogBusy">
        <mat-icon aria-hidden="true">create_new_folder</mat-icon>
        {{ view.translate('breadcrumbs.popover.create_option') }}
      </button>
      <button mat-button type="button" mat-dialog-close [disabled]="view.moveDialogBusy">{{ view.translate('breadcrumbs.modal.button.cancel') }}</button>
    </div>
  </div>
</ng-template>

<ng-template #createFolderDialog>
  <div class="drive-dialog">
    <h2 mat-dialog-title>{{ view.translate('breadcrumbs.modal.title') || 'Crear nueva carpeta' }}</h2>
    <form class="drive-dialog-form" (ngSubmit)="view.confirmCreateFolder()" #folderForm="ngForm">
      <div mat-dialog-content class="drive-dialog-content">
        <mat-form-field appearance="outline" class="drive-dialog-field">
          <mat-label>{{ view.translate('breadcrumbs.modal.label') || 'Nombre de la carpeta' }}</mat-label>
          <input matInput [(ngModel)]="view.newFolderName" name="folderName" required>
        </mat-form-field>
      </div>
      <div mat-dialog-actions align="end" class="drive-dialog-actions">
        <button mat-button class="drive-dialog-button" mat-dialog-close type="button">{{ view.translate('breadcrumbs.modal.button.cancel') || 'Cancelar' }}</button>
        <button mat-flat-button class="drive-dialog-button primary" type="submit" [disabled]="!view.newFolderName">{{ view.translate('breadcrumbs.modal.button.create') || 'Crear' }}</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #generateSummaryDialog>
  <div class="generate-summary-dialog">
    <h2 mat-dialog-title class="gsd-title">{{ view.translate('drive.generateSummary.modalTitle') }}</h2>
    <div mat-dialog-content class="gsd-content">
      <p class="gsd-hint">{{ view.translate('drive.generateSummary.modalHint') }}</p>
      <ul class="gsd-list">
        <li class="gsd-item" *ngFor="let source of view.summarySources">
          <i class="fas fa-file-lines" aria-hidden="true"></i>
          <span>{{ source.filename }}</span>
        </li>
      </ul>
    </div>
    <div mat-dialog-actions align="end" class="gsd-actions">
      <button type="button" class="btn btn-outline" mat-dialog-close>{{ view.translate('common.cancel') }}</button>
      <button type="button" class="btn btn-primary" (click)="view.confirmGenerateSummary()">
        <i class="fas fa-wand-magic-sparkles" aria-hidden="true"></i>
        <span>{{ view.translate('drive.generateSummary.goToGenerate') }}</span>
      </button>
    </div>
  </div>
</ng-template>

<!-- R3.5 C10: historial de versiones (solo se abre con feature doc_versioning) -->
<ng-template #versionsDialog>
  <div class="versions-dialog">
    <h2 mat-dialog-title>{{ view.translate('documents.versions.title') }}</h2>
    <div mat-dialog-content class="versions-dialog-content">
      <p class="versions-file" *ngIf="view.versionHistoryItem">{{ view.displayName(view.versionHistoryItem.name) }}</p>

      <div class="versions-loading" *ngIf="view.versionHistoryLoading">
        <mat-spinner diameter="22"></mat-spinner>
      </div>

      <div class="versions-error" *ngIf="!view.versionHistoryLoading && view.versionHistoryError">
        <mat-icon aria-hidden="true">error_outline</mat-icon>
        <span>{{ view.versionHistoryError }}</span>
      </div>

      <div class="versions-empty" *ngIf="!view.versionHistoryLoading && !view.versionHistoryError && view.versionHistory.length === 0">
        <mat-icon aria-hidden="true">history</mat-icon>
        <span>{{ view.translate('documents.versions.empty') }}</span>
      </div>

      <ul class="versions-list" *ngIf="!view.versionHistoryLoading && view.versionHistory.length > 0">
        <li class="versions-item" *ngFor="let version of view.versionHistory">
          <span class="version-badge">v{{ version.versionNo }}</span>
          <span class="versions-item-body">
            <strong>{{ view.displayName(version.originalFilename) }}</strong>
            <small>
              {{ version.createdAt | date:'medium' }}
              <ng-container *ngIf="version.fileSizeBytes"> · {{ version.fileSizeBytes | fileSize }}</ng-container>
            </small>
          </span>
          <span class="versions-active-pill" *ngIf="version.isActive">{{ view.translate('documents.versions.active') }}</span>
        </li>
      </ul>
    </div>
    <div mat-dialog-actions align="end" class="versions-dialog-actions">
      <button mat-button type="button" mat-dialog-close>{{ view.translate('documents.versions.close') }}</button>
    </div>
  </div>
</ng-template>
